export default __webpack_public_path__ + "static/media/flurry_snowball_illustration.1f1eb313.png";